"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
exports.WordCard = (0, react_1.memo)(({ word, onClick, selected = false }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { onClick: onClick, alignItems: "center", direction: "row", spacing: 2, sx: {
            cursor: onClick ? "pointer" : "default",
        }, children: word.word.split("").map((unit) => ((0, jsx_runtime_1.jsx)(material_1.Stack, { alignItems: "center", justifyContent: "center", flex: "none", height: theme.spacing(8), width: theme.spacing(8), sx: {
                borderRadius: 2,
                border: selected
                    ? `2px solid ${theme.palette.primary.main}`
                    : `1px solid ${theme.palette.divider}`,
                backgroundColor: selected
                    ? theme.palette.action.selected
                    : theme.palette.background.paper,
            }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", children: unit }) }))) }));
});
exports.WordCard.displayName = "WordCard";
